/**
 * The lineup, restated as a chip strip: "1 QB · 2 RB · 3 WR · 1 TE · 1 FLEX ·
 * 6 Bench".
 *
 * Adopted from the FPTS Front Office LINEUP row. It does one job in two
 * places: at the top of the entry ladder it confirms the settings the user
 * just described before they spend five minutes typing a roster into the wrong
 * shape, and on the report it restates what the grades were measured against.
 *
 * Reads the same house position counts everything else on this tab reads, so
 * it cannot disagree with the ladder it sits above.
 */

import { theme } from "../../data/theme.js";
import { C, SZ } from "../Submit/submitStyles.js";

/** Display order and wording. SFLEX says SUPERFLEX, BN says Bench. */
const CHIP_ORDER = [
  ["QB", "QB"],
  ["RB", "RB"],
  ["WR", "WR"],
  ["TE", "TE"],
  ["FLEX", "FLEX"],
  ["SFLEX", "SUPERFLEX"],
  ["DEF", "DEF"],
  ["K", "K"],
  ["BN", "Bench"],
];

/** The chips as data, so a test can read the strip without touching the DOM. */
export function lineupChips(positions) {
  const p = positions || {};
  return CHIP_ORDER.filter(([key]) => (Number(p[key]) || 0) > 0).map(([key, word]) => ({
    key,
    label: `${Number(p[key])} ${word}`,
  }));
}

export default function LineupChips({ positions, onEdit }) {
  const chips = lineupChips(positions);
  if (chips.length === 0) return null;
  return (
    <div
      data-testid="lineup-chips"
      style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 6, marginBottom: 10 }}
    >
      {chips.map((chip) => (
        <span
          key={chip.key}
          style={{
            fontSize: SZ.micro,
            fontWeight: 700,
            letterSpacing: "0.5px",
            padding: "3px 8px",
            borderRadius: theme.radius.lg,
            border: `1px solid ${C.border.default}`,
            color: C.text.secondary,
            whiteSpace: "nowrap",
          }}
        >
          {chip.label}
        </span>
      ))}
      {onEdit && (
        <button
          type="button"
          onClick={onEdit}
          style={{
            border: "none",
            background: "transparent",
            padding: "3px 4px",
            fontSize: SZ.micro,
            color: C.brand.accent,
            fontWeight: 700,
            cursor: "pointer",
          }}
        >
          Not right? Edit settings
        </button>
      )}
    </div>
  );
}
